// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__95sjd","signatureButtonsRight":"ModalSign_signatureButtonsRight__2sQuC"};